export type PaywallVersion = 'v1' | 'v2'

export const usePaywallParams = () => {
  const route = useRoute()

  const getPaywallForce = () => {
    const paywallForce = route.query.paywall_force
    if (paywallForce === false || paywallForce === 'false') return false
    if (paywallForce !== undefined) return paywallForce === 'true' || paywallForce === true
    return true
  }

  const getPaywallClose = () => {
    const paywallClose = route.query.paywall_close
    if (paywallClose !== undefined) {
      return paywallClose === 'true' || paywallClose === true
    }
    return undefined
  }

  const getPaywallVersion = (): PaywallVersion => {
    const version = route.query.paywall_version
    if (version === 'v2') {
      return 'v2'
    }
    return 'v1'
  }

  return {
    getPaywallForce,
    getPaywallClose,
    getPaywallVersion,
  }
}
